// frontend/shared-ui/src/auth/PermissionsContext.jsx
import React, { createContext, useContext, useMemo } from "react";

const PermissionsContext = createContext({ permissions: [] });

export function PermissionsProvider({ permissions = [], children }) {
  const value = useMemo(() => ({ permissions }), [permissions]);
  return (
    <PermissionsContext.Provider value={value}>
      {children}
    </PermissionsContext.Provider>
  );
}

export function usePermissions() {
  return useContext(PermissionsContext);
}

/** Pure helper usable anywhere — takes a permission list */
export function checkPermission(userPermissions, requested) {
  if (!requested) return true;
  if (!Array.isArray(userPermissions)) return false;
  if (userPermissions.includes("*")) return true;
  if (userPermissions.includes(requested)) return true;
  const [resource] = requested.split(".");
  if (userPermissions.includes(`${resource}.*`)) return true;
  return false;
}
